<template>
  <v-container fluid class="pa-0 ma-0">
    <v-app id="inspire">
      <v-card class="elevation-0">
        <v-img class="white--text" max-height="590px" src="@/assets/aboutusbg.jpg">
          <v-container>
            <div class="mt-16 mx-lg-8 pt-lg-16">
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="5">
                  <v-card class="ma-2 mt-16">
                    <div class="waviy">
                      <h1 class="clrbluetext font-weight-bold">Privacy Policy Sactin</h1>
                      <h2 class="linespht spans clrbluetext font-weight-bold">
                        Discover. Discuss. Develop.
                      </h2>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="8" md="7">
                  <v-card
                    class="pa-2 ma-2 d-flex align-center justify-center htlargef mt-sm-16 mt-xl-8"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/dgxg.png"
                      class="fill-height zoom-effect"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-img>
      </v-card>

      <!-- start 3rd section -->
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Privacy Policy
                      </h1>
                      <p class="text-justify body-1">Effective date: February 16, 2024</p>
                      <p class="text-justify body-1">
                        SACTIN (“us”, “we”, or “our”) operates the SACTIN mobile
                        application (hereinafter referred to as the “Service”).
                      </p>
                      <p class="text-justify body-1">
                        This page informs you of our policies regarding the collection,
                        use, and disclosure of personal data when you use our Service and
                        the choices you have associated with that data.
                      </p>
                      <p class="text-justify body-1">
                        We use your data to provide and improve the Service. By using the
                        Service, you agree to the collection and use of information in
                        accordance with this policy. Unless otherwise defined in this
                        Privacy Policy, the terms used in this Privacy Policy have the
                        same meanings as in our Terms and Conditions.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Definitions
                      </h1>
                      <ul>
                        <li class="text-justify body-1">
                          <b> Service</b> Service is the SACTIN mobile application
                          operated by SACTIN
                        </li>
                        <li class="text-justify body-1">
                          <b>Personal Data</b>Personal Data means data about a living
                          individual who can be identified from those data (or from those
                          and other information either in our possession or likely to come
                          into our possession).
                        </li>
                        <li class="text-justify body-1">
                          <b>Usage Data </b>Usage Data is data collected automatically
                          either generated by the use of the Service or from the Service
                          infrastructure itself (for example, the duration of a page
                          visit).
                        </li>
                        <li class="text-justify body-1">
                          <b> Cookies</b>Cookies are small files stored on your device
                          (computer or mobile device).
                        </li>
                      </ul>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Information Collection and Use
                      </h1>
                      <p class="text-justify body-1">
                        We collect several different types of information for various
                        purposes to provide and improve our Service to you.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Types of Data Collected
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Personal Data
                      </h1>
                      <p class="text-justify body-1">
                        The personal information that you are asked to provide, and the
                        reasons why you are asked to provide it, will be made clear to you
                        at the point we ask you to provide your personal information.
                      </p>
                      <p class="text-justify body-1">
                        <b>Data collected, and for what purpose:</b>
                      </p>
                      <ul>
                        <li class="text-justify body-1">
                          First and last name. for App functionality, Fraud prevention,
                          security and compliance, Account management
                        </li>
                        <li class="text-justify body-1">Address (Optional)</li>
                        <li class="text-justify body-1">
                          Email address. (Optional) for Account management
                        </li>
                        <li class="text-justify body-1">Telephone number (Optional).</li>
                        <li class="text-justify body-1">
                          Other information that is not ordinarily available to the
                          public. (Optional) for App Functionality
                        </li>
                        <li class="text-justify body-1">
                          The User may be asked to enter some information when using the
                          website. The requested information will be used only when
                          requested to enter that information or following this Privacy
                          Policy.
                        </li>
                      </ul>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        IMAGE INFORMATION (PHOTOS AND VIDEOS)
                      </h1>
                      <p class="text-justify body-1">
                        Data collected, and for what purpose:
                      </p>
                      <ul>
                        <li class="text-justify body-1">
                          Videos (Optional) for App functionality
                        </li>
                        <li class="text-justify body-1">
                          Photos (Optional) for App functionality
                        </li>
                      </ul>
                      <p class="text-justify body-1">
                        Our website and application may collect user images for various
                        purposes, such as profile pictures or content submission. Please
                        be aware that any images submitted to our platform may be stored
                        on our servers for future use. However, we do not share these
                        images with third parties; they are only used for internal
                        purposes, such as improving our services and user experience. By
                        submitting an image to our platform, you acknowledge and consent
                        our collection and storage of your image.
                      </p>
                      <p class="text-justify body-1">
                        <b>How we use your information</b>
                      </p>
                      <p class="text-justify body-1">
                        We use the information we collect in various ways, including to:
                      </p>
                      <ul>
                        <li class="text-justify body-1">
                          Provide, operate, and maintain our website
                        </li>
                        <li class="text-justify body-1">
                          Improve, personalize, and expand our website
                        </li>
                        <li class="text-justify body-1">
                          Understand and analyze how you use our website
                        </li>
                        <li class="text-justify body-1">
                          Develop new products, services, features, and functionality
                        </li>
                        <li class="text-justify body-1">
                          Communicate with you, either directly or through one of our
                          partners, including for customer service, to provide you with
                          updates and other information relating to the website, and for
                          marketing and promotional purposes
                        </li>
                        <li class="text-justify body-1">Send you emails</li>
                        <li class="text-justify body-1">Find and prevent fraud</li>
                      </ul>

                      <p class="text-justify body-1 mt-6"><b>Usage Data</b></p>
                      <p class="text-justify body-1">
                        When you access the Service by or through a mobile device, we may
                        collect certain information automatically, including, but not
                        limited to, the type of mobile device you use, your mobile device
                        unique ID, the IP address of your mobile device, your mobile
                        operating system, the type of mobile Internet browser you use,
                        unique device identifiers and other diagnostic data (“Usage
                        Data”).
                      </p>
                      <p class="text-justify body-1 mt-6">
                        <b>Tracking & Cookies Data</b>
                      </p>
                      <p class="text-justify body-1">
                        We use cookies and similar tracking technologies to track the
                        activity on our Service and we hold certain information.
                      </p>
                      <p class="text-justify body-1">
                        Cookies are files with a small amount of data which may include an
                        anonymous unique identifier. Cookies are sent to your browser from
                        a website and stored on your device. Other tracking technologies
                        are also used such as beacons, tags and scripts to collect and
                        track information and to improve and analyse our Service.
                      </p>
                      <p class="text-justify body-1">
                        You can instruct your browser to refuse all cookies or to indicate
                        when a cookie is being sent. However, if you do not accept
                        cookies, you may not be able to use some portions of our Service.
                      </p>
                      <p class="text-justify body-1">Examples of Cookies we use:</p>
                      <ul>
                        <li class="text-justify body-1">
                          <b>Session Cookies.</b>We use Session Cookies to operate our
                          Service.
                        </li>
                        <li class="text-justify body-1">
                          <b>Preference Cookies.</b> We use Preference Cookies to remember
                          your preferences and various settings.
                        </li>
                        <li class="text-justify body-1">
                          <b>Security Cookies.</b>We use Security Cookies for security
                          purposes.
                        </li>
                      </ul>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Use of Data
                      </h1>
                      <p class="text-justify body-1">
                        SACTIN uses the collected data for various purposes:
                      </p>

                      <ul>
                        <li class="text-justify body-1">
                          To provide and maintain the Service
                        </li>
                        <li class="text-justify body-1">
                          To notify you about changes to our Service
                        </li>
                        <li class="text-justify body-1">
                          To allow you to participate in interactive features of our
                          Service when you choose to do so
                        </li>
                        <li class="text-justify body-1">
                          To provide customer care and support
                        </li>
                        <li class="text-justify body-1">
                          To provide analysis or valuable information so that we can
                          improve the Service
                        </li>
                        <li class="text-justify body-1">
                          To monitor the usage of the Service
                        </li>
                        <li class="text-justify body-1">
                          To detect, prevent and address technical issues
                        </li>
                      </ul>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Transfer Of Data
                      </h1>
                      <p class="text-justify body-1">
                        Your information, including Personal Data, may be transferred to –
                        and maintained on – computers located outside of your state,
                        province, country or other governmental jurisdiction where the
                        data protection laws may differ than those from your jurisdiction.
                      </p>
                      <p class="text-justify body-1">
                        If you are located outside India and choose to provide information
                        to us, please note that we transfer the data, including Personal
                        Data, to India and process it there.
                      </p>
                      <p class="text-justify body-1">
                        Your consent to this Privacy Policy followed by your submission of
                        such information represents your agreement to that transfer.
                      </p>
                      <p class="text-justify body-1">
                        SACTIN will take all steps reasonably necessary to ensure that
                        your data is treated securely and in accordance with this Privacy
                        Policy and no transfer of your Personal Data will take place to an
                        organization or a country unless there are adequate controls in
                        place including the security of your data and other personal
                        information.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Disclosure Of Data
                      </h1>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Legal Requirements
                      </h1>
                      <p class="text-justify body-1">
                        SACTIN may disclose your Personal Data in the good faith belief
                        that such action is necessary to:
                      </p>
                      <ul>
                        <li class="text-justify body-1">
                          To comply with a legal obligation
                        </li>
                        <li class="text-justify body-1">
                          To protect and defend the rights or property of SACTIN
                        </li>
                        <li class="text-justify body-1">
                          To prevent or investigate possible wrongdoing in connection with
                          the Service
                        </li>
                        <li class="text-justify body-1">
                          To protect the personal safety of users of the Service or the
                          public
                        </li>
                        <li class="text-justify body-1">
                          To protect against legal liability
                        </li>
                      </ul>
                      <p class="text-justify body-1 mt-6">
                        As an European citizen, under GDPR, you have certain individual
                        rights. You can learn more about these guides in the GDPR Guide.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Security of Data
                      </h1>
                      <p class="text-justify body-1">
                        The security of your data is important to us but remember that no
                        method of transmission over the Internet or method of electronic
                        storage is 100% secure. While we strive to use commercially
                        acceptable means to protect your Personal Data, we cannot
                        guarantee its absolute security.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Service Providers
                      </h1>
                      <p class="text-justify body-1">
                        We may employ third party companies and individuals to facilitate
                        our Service (“Service Providers”), to provide the Service on our
                        behalf, to perform Service-related services or to assist us in
                        analyzing how our Service is used.
                      </p>
                      <p class="text-justify body-1">
                        These third parties have access to your Personal Data only to
                        perform these tasks on our behalf and are obligated not to
                        disclose or use it for any other purpose.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Links to Other Sites
                      </h1>
                      <p class="text-justify body-1">
                        Our Service may contain links to other sites that are not operated
                        by us. If you click a third party link, you will be directed to
                        that third party’s site. We strongly advise you to review the
                        Privacy Policy of every site you visit.
                      </p>
                      <p class="text-justify body-1">
                        We have no control over and assume no responsibility for the
                        content, privacy policies or practices of any third party sites or
                        services.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Children’s Privacy
                      </h1>
                      <p class="text-justify body-1">
                        Our Service does not address anyone under the age of 18
                        (“Children”).
                      </p>
                      <p class="text-justify body-1">
                        We do not knowingly collect personally identifiable information
                        from anyone under the age of 18. If you are a parent or guardian
                        and you are aware that your Child has provided us with Personal
                        Data, please contact us. If we become aware that we have collected
                        Personal Data from children without verification of parental
                        consent, we take steps to remove that information from our
                        servers.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Changes to This Privacy Policy
                      </h1>
                      <p class="text-justify body-1">
                        We may update our Privacy Policy from time to time. We will notify
                        you of any changes by posting the new Privacy Policy on this page.
                      </p>
                      <p class="text-justify body-1">
                        We will let you know via email and/or a prominent notice on our
                        Service, prior to the change becoming effective and update the
                        “effective date” at the top of this Privacy Policy.
                      </p>
                      <p class="text-justify body-1">
                        You are advised to review this Privacy Policy periodically for any
                        changes. Changes to this Privacy Policy are effective when they
                        are posted on this page.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>

      <v-container fluid class="px-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <div>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card class="elevation-0">
                    <div class="waviy">
                      <h1
                        class="rainbow-text font-weight-bold linespht display-1 mb-6"
                        style="font-size: clamp(22px, 4vw, 32px) !important"
                      >
                        Contact Us
                      </h1>
                      <p class="text-justify body-1">
                        If you have any questions about this Privacy Policy, please
                        contact us:
                      </p>
                      <ul>
                        <li class="text-justify body-1">
                          By phone number: +91 9526 619 619
                        </li>
                      </ul>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card>
      </v-container>
      <!-- end 3rd section -->

      <!-- start footer -->
      <WebsiteFooter />
      <!-- end footer -->
    </v-app>
  </v-container>
</template>

<script>
import WebsiteFooter from "../WebsitePages/WebsiteFooter.vue";
export default {
  components: {
    WebsiteFooter,
  },
  data() {
    return {
      observer: null,
    };
  },
  methods: {
    getImage(imageName) {
      return require(`@/assets/${imageName}`);
    },
  },
  mounted() {
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer1.unobserve(entry.target); // run only once
          }
        });
      },
      { threshold: 0.2 } // trigger when 20% visible
    );

    document.querySelectorAll(".process-circle").forEach((el) => {
      observer1.observe(el);
    });
    const options = {
      root: null,
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const anim = entry.target.querySelector(".anim-item");
        if (!anim) return;

        if (entry.isIntersecting) {
          anim.classList.add("in-view"); // play animation
        } else {
          anim.classList.remove("in-view"); // reset when out of view
        }
      });
    }, options);

    [
      "leftHeadingMobile",
      "imageCard1",
      "imageCard2",
      "rightHeadingDesktop",
      "paragraph",
    ].forEach((ref) => {
      const el = this.$refs[ref];
      if (el) observer.observe(el);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
::v-deep .theme--light.v-icon {
  color: white;
}
::v-deep .theme--light.v-sheet {
  background-color: transparent !important;
  border-color: transparent !important;
  color: white;
}
::v-deep .theme--dark.v-sheet {
  background-color: transparent;
  border-color: transparent;
  color: black;
}
::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.linespht {
  line-height: 1.5;
  letter-spacing: 2px;
}
.linespht1 {
  line-height: 1.5;
  letter-spacing: 1px;
}
@media screen and (min-width: 1100px) and (max-width: 1300px) {
  .htlargef {
    height: 90% !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1670px) {
  .htlargef {
    height: 90% !important;
  }
  .fd50SS {
    font-size: 50px !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1671px) {
  .htlargef {
    height: 70% !important;
  }
  .fd50SS {
    font-size: 60px !important;
  }
  .htlargeproductscn {
    height: 710px !important;
  }
  .htlargecertificatescn {
    height: 710px !important;
  }
}
.htlargef2 {
  height: 100% !important;
}
.clrblues {
  background-color: #04357e !important;
  color: white;
}
@media screen and (min-width: 700px) {
  .fd20 {
    font-size: 20px;
  }
  .fd50 {
    font-size: 40px;
    line-height: 1.5;
    letter-spacing: 2px;
  }
  .fd50SS {
    font-size: 50px;
  }
  .htlargeproductscn {
    height: 1115px;
  }
  .fd20ss {
    font-size: 30px !important;
  }
}

/* start card */
.a-box {
  display: inline-block;
  width: 100% !important;

  text-align: center;
}

.img-container {
  height: 120px;
  width: 200px;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
  display: inline-block;
}

.text-container {
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2); */
  padding: 10px;
  border-radius: 20px;
  /* background: #e5e5e5; */
  background: white;
  margin: -120px 0px 0px 0px;
  line-height: 19px;
  font-size: 14px;
}

.text-container h3 {
  margin: 20px 0px 10px 0px;
  /* color: #04bcff; */
  font-size: 18px;
}
.brradius {
  border-radius: 12px !important;
}

/* start slider */
.v-slide-group__prev,
.v-slide-group__next {
  color: purple; /* Customize the arrow color */
}
/* end slider */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}
.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}

/* end a1 */

/* a2 */

.contentan {
  position: relative;
}

.contentan h2 {
  color: #fff;
  font-size: 3em;
  position: absolute;
  transform: translate(-50%, -50%);
}

.contentan h2:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 2px #04357e;
  /* -webkit-text-stroke: 2px  #2A65BF; */
}

.contentan h2:nth-child(2) {
  color: #04357e;
  animation: animate 4s ease-in-out infinite;
}

@keyframes animate {
  0%,
  100% {
    clip-path: polygon(
      0% 45%,
      16% 44%,
      33% 50%,
      54% 60%,
      70% 61%,
      84% 59%,
      100% 52%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      15% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.letpx {
  left: 80px;
}
/* end a2 */
.clrbluetext {
  /* color: #04357e !important; */
  color: black;
}

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}

.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-20px);
  }
}
.rainbow-text {
  background: linear-gradient(
    90deg,
    red,
    orange,
    yellow,
    green,
    blue,
    indigo,
    violet,
    red
  );
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-move 8s linear infinite;
}

@keyframes rainbow-move {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
/* end a1 */
.process-circle-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid #e29803;
  /* Vuetify primary color */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.process-circle-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.process-circle-num {
  position: absolute;
  bottom: -15px;
  background: #e29803;
  color: #fff;
  border-radius: 50%;
  padding: 5px 12px;
  font-weight: bold;
}
/* Shared hidden state */
.anim-item {
  opacity: 0;
  transition-property: opacity, transform;
  transition-duration: 800ms;
  transition-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);
}

/* When in-view */
.anim-item.in-view {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

/* Types */
.fade-up {
  transform: translateY(40px);
}
.fade-up.in-view {
  transform: translateY(0);
}

.fade-left {
  transform: translateX(40px);
}
.fade-left.in-view {
  transform: translateX(0);
}

.zoom-in {
  transform: scale(0.9);
}
.zoom-in.in-view {
  transform: scale(1);
}

/* Optional delay helpers */
.delay-100 {
  transition-delay: 0.1s;
}
.delay-150 {
  transition-delay: 0.15s;
}
.delay-200 {
  transition-delay: 0.2s;
}
.delay-300 {
  transition-delay: 0.3s;
}
@keyframes zoomInOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* zoom in */
  }
  100% {
    transform: scale(1); /* back to normal */
  }
}

.zoom-effect {
  animation: zoomInOut 6s ease-in-out infinite; /* continuous zoom */
  transition: transform 0.3s ease-in-out;
}

.process-circle {
  position: relative;
  background: white;
  border-radius: 50%;
  padding: 30px;
  text-align: center;
  transition: all 0.4s ease; /* smooth animation */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg); /* zoom + tilt */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* stronger glow */
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 10px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg); /* spin icon */
}

.process-circle-text h3 {
  margin: 0;
  font-size: 18px;
  transition: color 0.3s ease;
}

.process-circle:hover .process-circle-text h3 {
  color: #e29803; /* change text color on hover */
}
.process-circle {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
}

.process-circle.visible {
  opacity: 1;
  transform: translateY(0);
}

.process-circle:nth-child(1) {
  transition-delay: 0.2s;
}
.process-circle:nth-child(2) {
  transition-delay: 0.4s;
}
.process-circle:nth-child(3) {
  transition-delay: 0.6s;
}
.process-circle:nth-child(4) {
  transition-delay: 0.8s;
}
.process-circle {
  width: 150px; /* fixed width */
  height: 150px; /* equal height */
  border-radius: 50%; /* make it a circle */
  background: white;
  display: flex;
  flex-direction: column; /* stack icon + text + number */
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto; /* center inside column */
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg);
}

.process-circle-num {
  position: absolute;
  bottom: -20px; /* place number outside circle */
  font-weight: bold;
  font-size: 18px;
  color: white;
}
@keyframes pulseLoop {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  position: relative;
  cursor: pointer;

  /* 👇 add looping animation */
  animation: pulseLoop 3s ease-in-out infinite;
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle-num {
  position: absolute;
  bottom: -20px;
  font-weight: bold;
  font-size: 18px;
  color: white;
}
.fontfamMon {
  font-family: Montserrat !important;
}
</style>
